<template>
    <div>
        <h2
            v-t="'Teamzugehörigkeiten'"
            class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
        ></h2>

        <kgr-checkbox
            v-model="showOnlyActive"
            :label="$t('nur aktuelle Daten anzeigen')"
            class="kgr-row"
            @change="handleCheckbox()"
        />

        <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        v-t="'employee'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Start'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Ende'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="teamRelation in visibleRelations"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell kgr-grid--vertical">
                        <a
                            class="kgr-link kgr-link--unobtrusive"
                            :href="getLink(teamRelation.employee.id)"
                        >{{ teamRelation.employee.fullName }}</a>
                    </td>
                    <td class="kgr-table__cell kgr-grid--vertical">
                        <template v-if="isBeingEdited(teamRelation)">
                            <div class="form-widget without-label date-picker">
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(teamRelation)].start"
                                    :invalid="getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])"
                                />
                            </div>
                            <div v-if="getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])">
                                {{ getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ teamRelation.formattedStart() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell kgr-grid--vertical">
                        <template v-if="isBeingEdited(teamRelation)">
                            <div class="form-widget without-label date-picker  kgr-grid__cell">
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(teamRelation)].end"
                                    :invalid="getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])"
                                />
                            </div>
                            <div v-if="getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])">
                                {{ getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ teamRelation.formattedEnd() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions kgr-grid--vertical">
                        <kgr-icon-edit
                            v-if="teamRelation.isEditable"
                            :size="15"
                            :disabled="isBeingEdited(teamRelation)"
                            class="kgr-table__action"
                            @click="edit(teamRelation)"
                        />
                        <kgr-icon-delete
                            v-if="teamRelation.isDeletable"
                            class="kgr-table__action"
                            @click="remove(teamRelation)"
                        />
                    </td>
                </tr>

                <tr
                    v-if="isCreatable"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        <kgr-club-employee-select
                            ref="clubEmployeeSelect"
                            v-model="newRelation.employee"
                            :club-id="clubId"
                            hide-label
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.start"
                                :invalid="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationStartDate(newRelation) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.end"
                                :invalid="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationEndDate(newRelation) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
&nbsp;
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-button
            v-if="showSaveButton"
            class="button_save"
            :value="$t('saveChanges')"
            :disabled="!isSavable()"
            :pending="pendingCreate || pendingUpdate"
            @click="save()"
        />
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox';
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository';
import ClubEmployeeTeamRelation from '../../js/dto/ClubEmployeeTeamRelation';
import ClubEmployeesSelect from '../common/form/select/ClubEmployeesSelect';
import DatePicker from '../common/form/picker/DatePicker';
import Error from '../../js/model/Error';
import IconDelete from '../common/icon/IconDelete';
import IconEdit from '../common/icon/IconEdit';
import KgrButton from '../common/form/button/KgrButton';
import axios from 'axios';

const TEAM_EMPLOYEE_RELATION_SHOW_ONLY_ACTIVE = 'kgr:team:employee:relation:show_only_active';

export default {
    name: 'KgrTeamEmployeeRelationsForm',
    components: {
        'kgr-club-employee-select': ClubEmployeesSelect,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-button': KgrButton,
        'kgr-date-picker': DatePicker,
        'kgr-checkbox': Checkbox,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        teamId: {
            type: Number,
            required: true,
        },
        teamEmployeeRelations: {
            type: Array,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            newRelation: new ClubEmployeeTeamRelation(),
            editRelations: [],
            pendingCreate: false,
            pendingUpdate: false,
            showOnlyActive: false,
            alertMessages: [],
            newRelationIsInvalid: false,
        }
    },
    computed: {
        visibleRelations() {
            return this.teamEmployeeRelations
                .filter(relation => this.isActive(relation));
        },
        showSaveButton() {
            return this.isCreatable  ||
                this.teamEmployeeRelations.filter(r => r.isEditable).length > 0 ||
                this.teamEmployeeRelations.filter(r => r.isDeletable).length > 0;
        },
    },
    created() {
        let viewOnlyActive = localStorage.getItem(TEAM_EMPLOYEE_RELATION_SHOW_ONLY_ACTIVE);
        if (null !== viewOnlyActive && '' !== viewOnlyActive) {
            this.showOnlyActive = true;
        }
    },
    methods: {
        isErrorRelation(relation) {
            return relation !== undefined && relation.invalid;
        },
        getLink(employeeId) {
            return `/backend/clubs/employees/${employeeId}/show`;
        },
        handleCheckbox() {
            if (this.showOnlyActive) {
                localStorage.setItem(TEAM_EMPLOYEE_RELATION_SHOW_ONLY_ACTIVE, 'true');
            } else {
                localStorage.removeItem(TEAM_EMPLOYEE_RELATION_SHOW_ONLY_ACTIVE);
            }
        },
        isActive(teamRelation) {
            if (this.showOnlyActive && !this.isRelationCurrent(teamRelation)) {
                return false;
            }

            return true;
        },
        isRelationCurrent(teamRelation) {
            let today = new Date();
            today.setHours(0,today.getTimezoneOffset() * -1, 0, 0);
            if (!teamRelation.end) {
                if (teamRelation.start <= today) {
                    return true;
                }
            } else {
                if (teamRelation.start <= today && teamRelation.end >= today) {
                    return true;
                }
            }

            return false;
        },
        isBeingEdited(teamRelation) {
            return this.getEditIndex(teamRelation) !== -1;
        },
        getEditIndex(teamRelation) {
            return this.editRelations.map(editRelation => editRelation.id).indexOf(teamRelation.id);
        },
        isSavable() {
            if (this.editRelations.length === 0 && this.newRelation.isEmptyEmployee()) {
                return false;
            }

            let hasInvalidEdits = this.editRelations.filter(editRelation => !this.isValidDateRange(editRelation)).length > 0;
            if (hasInvalidEdits) {
                return false;
            }
            if (!this.newRelation.isEmptyEmployee() && !this.newRelation.isValidEmployee()) {
                return false;
            }

            return true;
        },
        isValidDateRange(teamRelation) {
            if (!teamRelation.end) {
                return true;
            }

            if (!teamRelation.start && teamRelation.end) {
                return false;
            }

            return this.getDateFromString(teamRelation.end) >=  this.getDateFromString(teamRelation.start);
        },
        getDateFromString(dateString) {
            let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;

            return new Date(dateString.replace(pattern,'$3-$2-$1'));
        },
        getErrorMessageForExistingStartDate(relation) {
            let editRelation = this.editRelations[this.getEditIndex(relation)];
            if (editRelation.invalid === true) {
                return this.$t('relation.error.overlapping');
            }
            if (!relation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!this.isValidDate(relation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(relation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForExistingEndDate(relation) {
            if (relation.end && !this.isValidDate(relation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (relation.start && !this.isValidDateRange(relation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationStartDate(newRelation) {
            if (this.newRelationIsInvalid) {
                return this.$t('{name} ist diesem Team im gewählten Zeitraum bereits zugewiesen.', {'name': this.newRelation.employee.fullName});
            }
            if (!newRelation.isEmptyEmployee() && !newRelation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!newRelation.isEmptyEmployee() && !this.isValidDate(newRelation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(newRelation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationEndDate(newRelation) {
            if (newRelation.end && !this.isValidDate(newRelation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (newRelation.start && !this.isValidDateRange(newRelation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        isValidDate(date) {
            return this.getRegexForDate().test(date);
        },
        getRegexForDate() {
            return new RegExp('^([0-2][0-9]|(3)[0-1])(\\.)(((0)[0-9])|((1)[0-2]))(\\.)\\d{4}$');
        },
        remove(teamRelation) {
            showConfirm(this.$t('confirm'), this.$t('team.relation.employee.confirm.delete', {'name': teamRelation.employee.fullName}), () => {
                this.editRelations = this.editRelations.filter(r => r.id !== teamRelation.id);
                ClubEmployeeRepository
                    .removeEmployeeTeamRelation(teamRelation.employee.id, teamRelation.id)
                    .then(() => {
                        this.$notify.success('team.relation.employee.delete.success', {'name': teamRelation.employee.fullName});
                        this.emitUpdated();
                    })
                    .catch(() => {
                        this.$notify.error('saveChanges.error');
                    });
            }, 'Ok');
        },
        edit(teamRelation) {
            if (this.isBeingEdited(teamRelation)) {
                return;
            }

            this.editRelations.push(teamRelation.toData());
        },
        save() {
            this.pendingCreate = true;
            this.pendingUpdate = true;
            let apiCalls = [];
            if (!this.newRelation.isEmptyEmployee()) {
                this.newRelationIsInvalid = false;
                apiCalls.push(this._createRelation());
            }
            if (this.editRelations.length > 0) {
                apiCalls.push(this._updateRelations(this.editRelations));
            }
            if (apiCalls.length === 0) {
                return;
            }

            axios.all(apiCalls)
                .then(() => {
                    if (this.alertMessages.length > 0 || this.newRelationIsInvalid) {
                        this.alertMessages = this.alertMessages.filter((value, index) => this.alertMessages.indexOf(value) === index);
                        this.$notify.error(this.alertMessages);
                    } else {
                        this.$notify.success('saveChanges.success');
                    }
                })
                .finally(() => {
                    this.editRelations = this.editRelations.filter(relation => relation.invalid === true);
                    this.emitUpdated();
                    this.pendingCreate = false;
                    this.pendingUpdate = false;
                    this.alertMessages = [];
                });

        },
        _createRelation() {
            this.newRelationIsInvalid = false;
            return ClubEmployeeRepository
                .createTeamRelation(this.teamId, this.newRelation, this.newRelation.employee.id)
                .then(() => {
                    this.newRelation = new ClubEmployeeTeamRelation();
                    this.newRelationIsInvalid = false;
                    this.$refs.clubEmployeeSelect.resetSelected();
                })
                .catch(error => {
                    this.newRelationIsInvalid = true;
                    if (error.status === 409) {
                        this.alertMessages.push(this.$t('{name} ist dieser Abteilung im gewählten Zeitraum bereits zugewiesen.', {'name': this.newRelation.employee.fullName}));
                    } else {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                    }
                })
        },
        _updateRelations(editRelations) {
            return axios.all(editRelations.map(teamRelation => {
                teamRelation.invalid = false;
                return ClubEmployeeRepository.updateTeamRelation(teamRelation)
                    .catch(() => {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                        teamRelation.invalid = true;
                    });
            }));
        },
        emitUpdated() {
            this.$emit('updated');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.button_save {
    display: block;
    margin-left: auto;
}

.hierarchyPath {
    font-size: 80%;
}
</style>
